export const normalizeUserPhone = (value = '') => {
  const rawPhone = String(value || '').trim();
  const digits = rawPhone.replace(/\D/g, '');

  return rawPhone.startsWith('+') ? `+${digits}` : digits;
};

export const isValidUserPhone = (value = '') => {
  const digits = normalizeUserPhone(value).replace(/\D/g, '');
  return digits.length >= 8 && digits.length <= 15;
};
